import React from 'react';

import type { SizeOptions } from '@uncinc/react-drupal-core/dist/Components/DynamicMediaItem';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { AspectRatiosList } from '../../hooks/useLayoutVariables';
import type { MediaReferenceField } from '../../types/uncinc_profile/helpers/media';

import {
  SCREEN_XS,
  SCREEN_SM,
  SCREEN_MD,
  SCREEN_LG,
  SCREEN_XL,
} from '../../config/constants';

interface VariableRatiosPictureProps {
  image: MediaReferenceField<'image'>;
  aspectRatios: AspectRatiosList;
  cropSizes?: [SizeOptions, SizeOptions, SizeOptions, SizeOptions, SizeOptions];
}

const VariableRatiosPicture: React.FC<VariableRatiosPictureProps> = ({
  image,
  aspectRatios,
  cropSizes = ['sm', 'md', 'md', 'lg', 'lg'],
}) => (
  // For images above the fold, we want to render a Picture component, not an Adaptive Picture.
  // However, when using the DynamicMediaItem with the prop 'aboveTheFold' we would create a sources
  // object consisting of only 'original' ratios because we don't have windowDimensions. (see useLayoutVariables)
  //
  // When the site is loaded by the browser, React recognizes that it should recalculate the imageratios,
  // however, the resulting HTML differs from what's being passed from the server, so React does not replace the HTML.
  //
  // TODO: https://uncinc.monday.com/boards/99020894/pulses/8667876706
  <Image
    src={{
      [SCREEN_XS]: image.styles?.[`ratio_${aspectRatios[0]}_${cropSizes[0]}`],
      [SCREEN_SM]: image.styles?.[`ratio_${aspectRatios[1]}_${cropSizes[1]}`],
      [SCREEN_MD]: image.styles?.[`ratio_${aspectRatios[2]}_${cropSizes[2]}`],
      [SCREEN_LG]: image.styles?.[`ratio_${aspectRatios[3]}_${cropSizes[3]}`],
      [SCREEN_XL]: image.styles?.[`ratio_${aspectRatios[4]}_${cropSizes[4]}`],
    }}
    lazyload={false}
    alt={image.alt}
  />
);

export default VariableRatiosPicture;
